module.exports = __webpack_public_path__ + "img/4.a335b43d.jpg";